// extracted by mini-css-extract-plugin
export var deliveryRow = "_ni-a";
export var fixedHeight = "_ni-4";
export var freightLogo = "_ni-9";
export var fullWidth = "_ni-3";
export var priceColumn = "_ni-5";
export var radioSelected = "_ni-7";
export var radioUnselected = "_ni-6";
export var selectedOption = "_ni-2";
export var selectedOptionContainer = "_ni-1";
export var selection = "_ni-0";
export var tallSkeletonText = "_ni-8";